import { TrueBase, css, html } from "../TrueBase/TrueBase";

export class TrueNav extends TrueBase {
  static get properties() {
    return {
      position: {
        type: String,
        reflect: true,
      },
      mainNav: {
        type: Boolean,
      },
      didScroll: {
        type: Boolean,
        reflect: false,
        attribute: false,
      },
      prevScroll: {
        type: Number,
        reflect: false,
        attribute: false,
      },
      hideThreshold: {
        type: Number,
      },
      scrollUpEvent: {
        type: Object,
        reflect: false,
        attribute: false,
      },
      scrollDownEvent: {
        type: Object,
        reflect: false,
        attribute: false,
      },
      sum: {
        type: Array,
        reflect: false,
        attribute: false,
      },
    };
  }

  constructor() {
    super();
    this.hideThreshold = 500;
    this.sum = [];
  }

  connectedCallback() {
    super.connectedCallback && super.connectedCallback();
    this.scrollUpEvent = new CustomEvent("true-nav-scroll-up", {
      detail: {
        element: this,
      },
    });

    this.scrollDownEvent = new CustomEvent("true-nav-scroll-down", {
      detail: {
        element: this,
      },
    });

    this.prevScroll = window.scrollY | document.documentElement.scrollTop;

    window.addEventListener("scroll", () => {
      this.didScroll = true;
    });

    setInterval(() => {
      if (this.didScroll) {
        this._hasScrolled();
        this.didScroll = false;
      }
    }, 250);
  }

  _hasScrolled() {
    const navContainerHeight = this.shadowRoot.querySelector(
      ".navigation-container"
    ).clientHeight;
    let curScroll = window.scrollY | document.documentElement.scrollTop;
    let curDirection = 0;
    let prevDirection = 0;
    let toggled;

    if (curScroll > this.prevScroll) {
      curDirection = 2;
    } else {
      curDirection = 1;
    }

    if (curDirection !== prevDirection) {
      toggled = this.toggleClassOnScroll(curDirection, curScroll);
    }

    this.prevScroll = curScroll;
    if (toggled) {
      prevDirection = curDirection;
    }
  }

  async toggleClassOnScroll(direction, scroll) {
    let toggle = true;
    let topDistance = await this._scrollDistance(scroll);
    this.sum.push(topDistance);
    let totalTopDistance = this.sum.reduce((a, b) => a + b * 2);
    if (direction === 2 && scroll > this.hideThreshold) {
      this.classList.remove("nav-scroll-up");
      this.classList.add("nav-scroll-down");
      this.dispatchEvent(this.scrollDownEvent);
      this.sum = [];
      totalTopDistance = 0;
    } else if (
      (direction === 1 && totalTopDistance > this.hideThreshold / 2) ||
      window.pageYOffset <= 75
    ) {
      this.classList.add("nav-scroll-up");
      this.classList.remove("nav-scroll-down");
      this.dispatchEvent(this.scrollUpEvent);
    } else {
      toggle = false;
    }

    return toggle;
  }

  _scrollDistance(start) {
    let end, distance;

    // Set a timeout to run after scrolling ends
    let promise = new Promise((resolve, reject) => {
      setTimeout(function () {
        // Calculate distance
        end = window.pageYOffset;
        distance = parseInt(Math.abs(end - start));
        resolve(distance);
      }, 200);
    });

    return promise;
  }

  render() {
    return html`
      ${this.position === "sticky" ? html`<div class="nav-top"></div>` : ``}
      <nav role="navigation">
        <div class="navigation-container">
          <slot></slot>
        </div>
      </nav>
    `;
  }

  static get styles() {
    return [
      super.styles,
      css`
        :host {
          display: block;
          --button-margin: 0;
          z-index: var(--nav-z-index, 9999);
        }

        nav {
          position: relative;
          width: 100%;
          background-color: var(--nav-background-color, white);
          border-bottom: var(--nav-border-bottom, none);
        }

        .nav-top {
          height: 0px;
        }

        * {
          box-sizing: border-box;
        }

        :host([position="fixed"]) {
          position: fixed;
        }

        :host([position="sticky"]) {
          position: sticky;
          position: -webkit-sticky;
          top: var(--nav-sticky-top, 0);
        }

        :host([position="side-left"]) {
          position: fixed;
          top: 0;
          bottom: 0;
          left: 0;
          width: var(--nav-side-max-width, 300px);
        }

        :host([position="side-left"]) nav,
        :host([position="side-right"]) nav {
          height: 100%;
        }

        :host([position="side-right"]) {
          position: fixed;
          top: 0;
          bottom: 0;
          right: 0;
          width: var(--nav-side-max-width, 300px);
        }

        .navigation-container {
          display: flex;
          flex-wrap: var(--nav-container-flex-wrap, nowrap);
          justify-content: var(--nav-justify-content, space-between);
          align-items: center;
          width: 100%;
          margin: 0 auto;
          padding: var(--nav-container-padding, 16px 42px);
          max-width: var(--nav-container-max-width, 1284px);
          background-color: var(--nav-container-background-color, white);
          position: var(--nav-container-position, relative);
        }
      `,
    ];
  }
}

window.customElements.get("true-nav") ||
  window.customElements.define("true-nav", TrueNav);
